import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ChooseSku extends Vue {
  data = {};

  render(h) {
    return (
      <div style="position: relative;width: 100%;font-size: 14px;background: #fff">
        <div style="width: 100%;display: flex;padding: 8px 8px 2px">
          <div style="color: #999999;width: 15%;text-align: center">选择</div>
          <div style="color: #333333;width: 70%;text-align: left;padding-left: 16px">请选择尺寸</div>
          <div style="color: #999999;width: 15%;text-align: center;">
            <i class="iconfont icongengduo" style="font-size: 8px" />
          </div>
        </div>
        <div style="width: 100%;display: flex;padding: 2px 8px 8px">
          <div style="color: #999999;width: 15%;text-align: center">参数</div>
          <div style="color: #333333;width: 70%;text-align: left;padding-left: 16px">货号 品牌...</div>
          <div style="color: #999999;width: 15%;text-align: center;">
            <i class="iconfont icongengduo" style="font-size: 8px" />
          </div>
        </div>
      </div>
    );
  }
}
